import { TextField } from '@mui/material'
import React , { useEffect } from 'react'

const TextFormField = (({
    value,
    label,
    name,
    onHandleChange,
    width=false,
    className='',
}) => {

    const [localValue, setLocalValue] = React.useState(value);
    const [initialValue, setInitialValue] = React.useState(value);

     useEffect(() => {
        setLocalValue(value);
    },[value]);
    
    const handleChange = (event) => {
        setLocalValue(event.target.value);
    };

    const handleFocus = () => {
        setInitialValue(localValue);
    }

    const handleBlur = () => {
        if(localValue !== initialValue){
            onHandleChange(name,localValue);
        }
    }
    
    return (
        <TextField
            sx={{ 
                width: { 
                    xs: '100%', 
                    sm:width === false ? '30%':'100%',  
                    md:width === false ? '24%':'100%' 
                } 
            }}
            className={className}
            margin="dense"
            label={label}
            key={name}
            name={name}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
        />
    )
});

export default TextFormField